import React from 'react';

export type Settings = {
  /**
   * In kiosk mode long press opens context menu and cancels any
   * ongoing mouse gestures. Because there is no context menu in
   * the kiosk app, the result is that long press just cancels
   * tap action, so after releasing the finger there is no action.
   * This option counts context menu open as a click action.
   * Only use this in kiosk mode!
   */
  contextMenuEventIsClick?: boolean;
  /**
   * In iOS, it is not possible to autofocus into text fields,
   * because displaying keyboard requires a user action.
   * So temporarily we disable autofocus for iOS.
   */
  disableAutoFocus?: boolean;

  /**
   * Sets the width of the content for flow controls.
   * This is used in react-native, because there is no way
   * to get the width of the parent view.
   */
  contentWidth?: number;
};
const SettingsContext = React.createContext<Settings>({
  contextMenuEventIsClick: false,
  disableAutoFocus: false,
  contentWidth: 480,
});

export default SettingsContext;
